'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (history, catchAllHandler) {
  return function (next) {
    return function (reducer, initialState) {
      var store = next(reducer, initialState);

      return _extends({}, store, {
        dispatch: function dispatch(action) {
          var type = action.type;
          var meta = action.meta;

          var transitionMetaFunc = meta ? meta.transition || catchAllHandler : catchAllHandler;

          var prevState = transitionMetaFunc && store.getState();

          store.dispatch(action);

          var nextState = transitionMetaFunc && store.getState();

          var transitionData = transitionMetaFunc && transitionMetaFunc(prevState, nextState, action);

          if (transitionData) {
            var path = transitionData.path;
            var query = transitionData.query;
            var replace = transitionData.replace;
            var state = transitionData.state;

            var method = replace ? 'replaceState' : 'pushState';

            history[method](state, path, query);
          }

          return action;
        }
      });
    };
  };
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-history-transitions/lib/index.js
 ** module id = 656
 ** module chunks = 0
 **/